<div class="p-col-12 mu-without-padding">
  <div class="p-grid mu-mobile-column-reverse" [ngClass]="{ 'mu-column-reverse': alwaysFullWidth }">
    <div class="p-col-12 p-md-{{ alwaysFullWidth ? '12' : '6' }} mu-without-padding">
      <div class="p-grid mu-justify-content-end">
        <div class="p-col-12 p-lg-{{ customGridCol || '6' }} mu-without-padding">
          <ng-content select="[muButtonLeft]"></ng-content>
        </div>
      </div>
    </div>
    <div class="p-col-12  p-md-{{ alwaysFullWidth ? '12' : '6' }} mu-without-padding">
      <div class="p-grid">
        <div class="p-col-12 p-lg-{{ customGridCol || '6' }} mu-without-padding">
          <ng-content select="[muButtonRight]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
